import React from "react";
import Summary from "./Summary";
import ProcessingBar from "utils/Processingbar";
import Button from "components/Button";

const MobileConfirmModal = ({
  isOpen,
  onClose,
  formData,
  totalAmount,
  isProcessing,
  onPlaceOrder,
  cart,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black bg-opacity-90 flex justify-center items-center md:hidden">
      <div className="w-full max-w-md p-3 m-3 bg-dry border border-textGray rounded-xl rounded-2xl shadow-lg relative">
        <h3 className="text-lg  text-center mb-4  pb-3 uppercase">
          Confirm Your Order
        </h3>

        <Summary
          cart={cart}
          formData={formData}
          totalAmount={totalAmount}
          isProcessing={isProcessing}
          onPlaceOrder={onPlaceOrder}
        />

        {/* Action Button */}
        <div className="pt-3 flex justify-center space-x-3">
          <Button
            inverse
            onClick={onClose}
            className="min-w-[100px]"
            aria-label="Close confirmation modal"
          >
            Cancel
          </Button>
          <Button
            big
            onClick={onPlaceOrder}
            disabled={isProcessing}
            className="px-3 py-2 rounded-full min-w-[100px] bg-redlight text-white"
          >
            {isProcessing ? (
              <ProcessingBar />
            ) : formData.paymentMethod === "online" ? (
              "💳 Stripe"
            ) : (
              "Place Order"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileConfirmModal;
